import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import { NotEmptyString, ValidAddress } from "../../../../Validation/Validation";

export const AccountAddressSchema: ISchema = {
    displayName: "Account address",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'title',
            displayName: 'Title',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Title cannot be empty",
        } as ISchemaProperty,
        {
            name: 'address',
            displayName: 'Address',
            type: PropertyTypes.address,
            key: false,
            showInList: false,
            showInForm: true,
            group: 0,
            showInView: false,
            requiredInForm: true,
            validateRule: ValidAddress as Function
        } as ISchemaProperty,
        {
            name: 'isDefault',
            displayName: 'Is default?',
            descriptor: true,
            type: PropertyTypes.bool,
            key: false,
            showInList: false,
            showInForm: true,
            group: 1,
            showInView: false,
            requiredInForm: false,
            className: "small-12"
        } as ISchemaProperty,
    ],

    filters: []
}
